import { SvgAttribute } from "@/shared/constants/constants";

export const COMPONENT_NAME = "shared-window";

export const SVG: SvgAttribute = {
  close: `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0045 5.70518C20.3335 6.03423 20.3335 6.56773 20.0045 6.89678L14.0465 12.8548L20.0045 18.8128C20.3335 19.1419 20.3335 19.6754 20.0045 20.0044C19.6754 20.3335 19.1419 20.3335 18.8129 20.0044L12.8549 14.0464L6.89683 20.0044C6.56778 20.3335 6.03428 20.3335 5.70522 20.0044C5.37617 19.6754 5.37617 19.1419 5.70522 18.8128L11.6633 12.8548L5.70522 6.89678C5.37617 6.56773 5.37617 6.03423 5.70522 5.70518C6.03428 5.37612 6.56778 5.37612 6.89683 5.70518L12.8549 11.6632L18.8129 5.70518C19.1419 5.37612 19.6754 5.37613 20.0045 5.70518Z" fill="#9E9FA8"/>
  </svg>`,
};
